import { useTranslation } from "react-i18next";

interface StripItem {
  title: string;
  body: string;
}

/** Four short value props directly under the hero. */
export function FeatureStrip() {
  const { t } = useTranslation("landing");
  const items = t("strip.items", { returnObjects: true }) as StripItem[];

  return (
    <section className="mx-auto max-w-[1200px] px-5 pt-10 md:px-10 md:pt-16">
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {items.map((item) => (
          <div key={item.title} className="border-l border-border pl-4">
            <h2 className="text-[15px] font-semibold">{item.title}</h2>
            <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{item.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
